import axios from "axios";
import { useQuery } from "react-query";
import { API_URL, imageUrl } from "../../api/config";

const fetchStudies = async () => {
    const { data } = await axios.get(`${API_URL}/api/v1/clubs`);
    return data.map((item: any) => ({
        ...item,
        image: imageUrl(item.image),
        description: cleanDescription(item.description)
    }));
};

const cleanDescription = (description: any) => {
    let cleanedString = description.replace(/<\/?[^>]+(>|$)/g, '');
    cleanedString = cleanedString.replace(/&[^;\s]+;/g, '');
    let resultArray = cleanedString.split(/\s*<br\s*\/?>\s*/).map((s: any) => s.trim()).filter(Boolean);
    return resultArray.join(' ');
};

export const useStudies = () => {
    const { data, isLoading } = useQuery("studies", fetchStudies, {
        onError: (error) => {
            console.log("error", error);
        }
    });

    return {
        studies: data,
        isLoading
    };
};
